/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Who authored a message in an agent-chat transcript.
 */
export enum EnumChatMessageRole {
    /**
     * The instructions the agent runs under. Never shown to the user.
     */
    System = 0,
    /**
     * Typed by the user.
     */
    User = 1,
    /**
     * Produced by the model, either as text or as one or more tool calls.
     */
    Assistant = 2,
    /**
     * The result of one tool call, answering the call of the same id.
     */
    Tool = 3,
}
